<div class="modal-header text-center">
  Session is expired
</div>
<div class="modal-body text-center">
  <p>You session is expired.</p>
  <p>To continue your session, select <strong>Sign In</strong>.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="signIn()">Sign In</button>
  <button type="button" class="btn btn-secondary" (click)="signOut()">Sign out</button>
</div>